module.exports = __webpack_public_path__ + "img/cb3p-l-rr1.2a1fd8a2.gif";